import $ from "@modules/jquery";

// Swiper komt sinds de SOIL-migratie uit de plugin (@modules), niet meer uit een
// eigen theme-dependency. Vanaf Swiper 9 zitten de modules in "swiper/modules".
import Swiper from "@modules/swiper";
import {
  Navigation,
  Pagination,
  Scrollbar,
  Autoplay,
  Thumbs,
  Controller,
  EffectCoverflow,
} from "@modules/swiper/modules";

Swiper.use([Navigation, Pagination, Scrollbar, Autoplay, Thumbs, Controller, EffectCoverflow]);


$(document).ready(function () {
  $(".print-summary-button").click(function () {
    const printContent = document.querySelector(".print-summary");
    const print = window.open(
      "",
      "",
      "left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0"
    );
    print.document.write(printContent.innerHTML);
    print.document.close();
    print.focus();
    print.print();
  });

  $('.has-fixed-layout > tbody  > tr').each(function () {
    if ($(this).find('.has-text-align-left').is(':empty')) {
        $(this).hide();
    }
  });
 
});
// Bootgalerij. Alleen initialiseren als de markup er is: dit bestand wordt op
// elke pagina geladen en new Swiper op een lege selector levert geen instantie
// met een bruikbare controller op.
if (document.querySelector('.gallery-slider') && document.querySelector('.gallery-thumbs')) {
  const slider = new Swiper('.gallery-slider', {
    slidesPerView: 1,
    centeredSlides: true,
    loop: true,
    loopedSlides: 5,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  });

  const thumbs = new Swiper('.gallery-thumbs', {
    slidesPerView: 5,
    spaceBetween: 10,
    centeredSlides: true,
    loop: true,
    slideToClickedSlide: true,
  });

  slider.controller.control = thumbs;
  thumbs.controller.control = slider;
}

//Print chrome image for images
function PopUp(data) {
    var mywindow = window.open('','','left=0,top=0,width=950,height=600,toolbar=0,scrollbars=0,status=0,addressbar=0');

    var is_chrome = Boolean(mywindow.chrome);
    var isPrinting = false;
    mywindow.document.write(data);
    mywindow.document.close(); 


    if (is_chrome) {
        mywindow.onload = function() { // wait until all resources loaded 
            isPrinting = true;
            mywindow.focus(); 
            mywindow.print();  
            mywindow.close();
            isPrinting = false;
        };
        setTimeout(function () { if(!isPrinting){mywindow.print();mywindow.close();} }, 300);
    }
    else {
        mywindow.document.close(); 
        mywindow.focus(); 
        mywindow.print();
        mywindow.close();
    }

    return true;
}
